import { NoDataReason } from '@cast/types';

import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import {
  TopMostExpensiveGroup,
  TopMostExpensiveGroupDatapoint,
} from 'types/top-items';

import { useNetworkCostOverTimeQuery } from '../../../../hooks/useNetworkCostOverTimeQuery';

type TopMostExpensiveWorkloads = {
  data: TopMostExpensiveGroup[];
  datapoints: TopMostExpensiveGroupDatapoint;
  noDataReason?: NoDataReason;
  isLoading: boolean;
  error?: unknown;
  refetch?: () => void;
};

export const useTopMostExpensiveWorkloads = (): TopMostExpensiveWorkloads => {
  const { currentDateRange, adjustedDateRange } = useCostReportContext();

  const { topItems, datapoints, noDataReason, isLoading, error, refetch } =
    useNetworkCostOverTimeQuery({ currentDateRange, adjustedDateRange });

  return {
    data: topItems,
    datapoints,
    noDataReason,
    isLoading,
    error,
    refetch,
  };
};
